import React from 'react';
import { motion } from 'framer-motion';

function Web3Section() {
  const features = [
    {
      title: 'Military-Grade Encryption',
      description: 'Bank-level AES-256 encryption with zero-knowledge architecture ensuring your financial data and digital assets remain completely private and secure.',
    },
    {
      title: 'Multi-Layer Asset Protection',
      description: 'Advanced security protocols including multi-signature authentication, cold storage solutions, and real-time threat monitoring to safeguard your wealth.',
    },
    {
      title: 'Secure Custody Solutions',
      description: 'Institutional-grade custody with hardware security modules (HSM), multi-party computation (MPC), and segregated storage for maximum asset protection.',
    },
  ];

  const securityFeatures = [
    '2FA/MFA',
    'Cold Storage',
    'HSM Protected',
    'Biometric Auth',
    'End-to-End Encryption',
  ];

  return (
    <section className="py-20 bg-[#0b1020]">
      <div className="max-w-7xl mx-auto px-6">
        <div
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-semibold text-white mb-4">Asset Protection & Encryption</h2>
          <p className="text-lg text-white/70 max-w-3xl mx-auto text-center">
            Enterprise-grade security infrastructure protecting your wealth with military-level encryption, multi-layer authentication, and institutional custody solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {features.map((f, i) => (
            <div
              key={f.title}
              data-aos="fade-up"
              data-aos-delay={`${200 + i * 150}`}
              className="relative p-8 bg-white/5 border border-white/10 rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.25)] backdrop-blur-sm transition-all duration-500 hover:translate-y-[-2px] hover:bg-white/7"
            >
              <div className="w-12 h-12 rounded-full bg-[#fbbf24] flex items-center justify-center shadow-md mb-5">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-3">{f.title}</h3>
              <p className="text-white/70 leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-right" data-aos-delay="150">
            <div className="w-full h-80 rounded-2xl overflow-hidden shadow-[0_10px_40px_rgba(0,0,0,0.35)] ring-1 ring-white/10">
              <img
                src="/images/lines-5475657_640.jpg"
                alt="Digital assets visualization"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div data-aos="fade-left" data-aos-delay="250">
            <h3 className="text-3xl font-semibold text-white mb-4">Secure Your Wealth</h3>
            <p className="text-white/70 text-lg leading-relaxed mb-6">
              Protect your assets with our comprehensive security infrastructure featuring advanced encryption, multi-factor authentication, and institutional-grade safeguards.
            </p>
            <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
              {securityFeatures.map((feature) => (
                <li key={feature} className="px-4 py-2 rounded-full bg-white/10 text-white/80 text-sm border border-white/10 flex items-center justify-center gap-2">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#fbbf24]">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
            <motion.a
              href="/contact"
              className="inline-block px-8 py-4 rounded-full bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] hover:from-[#f59e0b] hover:to-[#d97706] text-black font-medium transition-all duration-500 shadow-xl hover:shadow-amber-500/25"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Secure My Assets
            </motion.a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Web3Section;


